module.exports = __webpack_public_path__ + "static/media/sg6tj168.01e28cfa.png";